module.exports = __webpack_public_path__ + "static/logo-mobile-62849ab881b88c4e3d4761de610b226c.svg";